export enum FUNDING_METHODS {
  STANDARD_NOTIONAL = 'STANDARD_NOTIONAL',
  PREFUND_SPENDDOWN = 'PREFUND_SPENDDOWN',
  PREFUND_AND_CONTRIBUTION = 'PREFUND_AND_CONTRIBUTION',
  CONTRIBUTION_ONLY = 'CONTRIBUTION_ONLY',
}

export const FUNDING_METHODS_OPTIONS = [
  { key: FUNDING_METHODS.STANDARD_NOTIONAL, value: 'Standard Notional' },
  { key: FUNDING_METHODS.PREFUND_SPENDDOWN, value: 'Prefund Spenddown' },
  { key: FUNDING_METHODS.PREFUND_AND_CONTRIBUTION, value: 'Prefund and Contribution' },
  { key: FUNDING_METHODS.CONTRIBUTION_ONLY, value: 'Contribution Only' },
];

export enum BillingMethod {
  PULL = 'PULL_FUNDS',
  PUSH = 'PUSH_FUNDS',
}

export const BILLING_METHOD_OPTIONS = [
  { label: 'Pull funds', value: BillingMethod.PULL },
  { label: 'Push funds', value: BillingMethod.PUSH },
];